(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-home-points"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.querySelector('.outlets-section');
  const preview = section && section.querySelector('.outlets-hover-img');
  if (!preview || !window.matchMedia('(min-width: 1024px)').matches) return;

  const photo = preview.querySelector('.outlets-hover-img__photo');
  const logo  = preview.querySelector('.outlets-hover-img__logo');
  const items = section.querySelectorAll('.outlet-item');
  if (!items.length) return;

  preview.style.display = 'block';

  // Preload all images/logos so switches are instantaneous during fast hover
  (function preload() {
    const seen = new Set();
    items.forEach(function (row) {
      if (row.dataset.img && !seen.has(row.dataset.img)) {
        const i = new Image();
        i.src = row.dataset.img;
        seen.add(row.dataset.img);
      }
      if (row.dataset.logo && !seen.has(row.dataset.logo)) {
        const i2 = new Image();
        i2.src = row.dataset.logo;
        seen.add(row.dataset.logo);
      }
    });
  }());

  function fillFrom(row) {
    if (!row) return false;
    if (!row.dataset.img) return false;

    // Immediately swap src; preloading above ensures the image will be cached
    photo.src = row.dataset.img;

    if (row.dataset.logo) {
      logo.src = row.dataset.logo;
      logo.style.display = 'block';
    } else {
      logo.style.display = 'none';
      logo.src = '';
    }

    return true;
  }

  function centerOn(row) {
    const rect = row.getBoundingClientRect();
    preview.style.left = (rect.left + rect.width / 2) + 'px';
    preview.style.top  = (rect.top + rect.height / 2) + 'px';
  }

  // Default state: centered on the first outlet item, same look as hover state
  const firstItem = items[0];
  if (fillFrom(firstItem)) {
    centerOn(firstItem);
    preview.classList.add('is-visible');
  }

  items.forEach(function (row) {
    row.addEventListener('mouseenter', function () {
      if (!fillFrom(row)) return;
      preview.classList.add('is-visible');
    });
    row.addEventListener('mouseleave', function () {
      preview.classList.remove('is-visible');
    });
    row.addEventListener('mousemove', function (e) {
      preview.style.left = e.clientX + 'px';
      preview.style.top  = e.clientY + 'px';
    });
  });

  // Keep the default preview centered on the first item if the viewport resizes
  // before any hover interaction has moved it.
  window.addEventListener('resize', function () {
    if (preview.dataset.userMoved) return;
    centerOn(firstItem);
  });

  section.addEventListener('mousemove', function () {
    preview.dataset.userMoved = '1';
  }, { once: true });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-points-list"] && !Shopify.designMode) return;
  try {
    
class PointsList extends HTMLElement {
  connectedCallback() {
    this.perPage = parseInt(this.dataset.perPage, 10) || 6;
    this.cards = Array.from(this.querySelectorAll('.plist-card-wrap'));
    this.totalPages = Math.ceil(this.cards.length / this.perPage);
    this.currentPage = 1;
    this.paginationEl = this.querySelector('.points-list__pagination');

    if (this.totalPages > 1 && this.paginationEl) {
      this.setupPagination();
    }
    this.showPage(1);
  }

  showPage(page) {
    this.currentPage = Math.min(Math.max(page, 1), this.totalPages);
    const start = (this.currentPage - 1) * this.perPage;
    const end = start + this.perPage;
    this.cards.forEach((card, i) => {
      card.hidden = i < start || i >= end;
    });
    if (this.totalPages > 1 && this.paginationEl) {
      this.updatePagination();
    }
  }

  setupPagination() {
    this.paginationEl.innerHTML = this.renderPaginationHTML();
    this.paginationEl.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-page]');
      if (!btn || btn.disabled) return;
      const p = btn.dataset.page;
      if (p === 'prev') this.showPage(this.currentPage - 1);
      else if (p === 'next') this.showPage(this.currentPage + 1);
      else this.showPage(parseInt(p, 10));
      this.scrollToSection();
    });
  }

  scrollToSection() {
    const section = this.closest('.points-list-section');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  updatePagination() {
    this.paginationEl.innerHTML = this.renderPaginationHTML();
  }

  getPageNumbers() {
    if (this.totalPages <= 5) {
      return Array.from({ length: this.totalPages }, (_, i) => i + 1);
    }
    return [1, 2, 3, '…', this.totalPages];
  }

  renderPaginationHTML() {
    const left = `<svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5362 4.87724L10.5369 3.32561L10.5369 4.87793L2.64198 4.87723L10.5362 4.87724ZM4.86965 0.768558L2.08058 3.55762L10.3041 3.55832L10.3048 4.64591L2.08058 4.64452L4.86965 7.43359L4.10108 8.20216L0.000690534 4.10176L4.10108 -6.58946e-06L4.86965 0.768558Z" fill="currentColor"/></svg>`;
    const right = `<svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.33877 0.769206L7.89513 3.32418L0.000251703 3.32487L0.000251834 4.87719L0.000942237 3.32556L7.89582 3.32487L5.33946 0.768516L5.33877 0.769206ZM5.66815 0.768516L8.45722 3.55758L0.232962 3.55758L0.232271 4.64517L8.45722 4.64448L8.05878 5.04154L5.66746 7.43286L6.43603 8.20142L10.5364 4.10103L6.43672 -4.84774e-05L5.66815 0.768516Z" fill="currentColor"/></svg>`
    let html = `<button class="plist-page-btn txt-15 plist-page-btn--arrow" data-page="prev" aria-label="Page précédente"${this.currentPage === 1 ? ' disabled' : ''}>${left}</button>`;
    this.getPageNumbers().forEach((p) => {
      if (p === '…') {
        html += `<span class="plist-page-btn txt-15 plist-page-btn--ellipsis">…</span>`;
      } else {
        html += `<button class="plist-page-btn txt-15${p === this.currentPage ? ' is-active' : ''}" data-page="${p}">${p}</button>`;
      }
    });
    html += `<button class="plist-page-btn txt-15 plist-page-btn--arrow" data-page="next" aria-label="Page suivante"${this.currentPage === this.totalPages ? ' disabled' : ''}>${right}</button>`;
    return html;
  }
}
customElements.define('points-list', PointsList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-points-official-oldmaps"] && !Shopify.designMode) return;
  try {
    
/* Points Official — Google Maps JS API integration.
   All config is read from DOM JSON blobs so this block stays pure JS. */
(function () {
  // Brand-tinted map styles — colours from brand token list (§3)
  var MAP_STYLES = [
    { elementType: 'geometry',                                          stylers: [{ color: '#fff7e9' }] },
    { featureType: 'administrative',  elementType: 'geometry',          stylers: [{ color: '#fff7e9' }] },
    { featureType: 'administrative',  elementType: 'labels',            stylers: [{ visibility: 'off' }] },
    { featureType: 'administrative.locality', elementType: 'geometry.fill',      stylers: [{ color: '#362b16' }] },
    { featureType: 'administrative.locality', elementType: 'labels.text.fill',   stylers: [{ color: '#362b16' }] },
    { featureType: 'landscape',               elementType: 'labels',             stylers: [{ visibility: 'off' }] },
    { featureType: 'landscape.man_made',      elementType: 'geometry',           stylers: [{ color: '#e0d5c0' }] },
    { featureType: 'landscape.natural',       elementType: 'geometry',           stylers: [{ color: '#e0d5c0' }] },
    { featureType: 'poi',                     elementType: 'labels',             stylers: [{ visibility: 'off' }] },
    { featureType: 'poi.business',            elementType: 'geometry',           stylers: [{ color: '#fff7e9' }] },
    { featureType: 'poi.park',                elementType: 'geometry',           stylers: [{ color: '#fff5e9' }] },
    { featureType: 'poi.park',                elementType: 'geometry.fill',      stylers: [{ color: '#efe4cf' }, { visibility: 'on' }] },
    { featureType: 'road',                    elementType: 'geometry.stroke',    stylers: [{ visibility: 'off' }] },
    { featureType: 'road',                    elementType: 'labels',             stylers: [{ visibility: 'off' }] },
    { featureType: 'road',                    elementType: 'labels.icon',        stylers: [{ visibility: 'off' }] },
    { featureType: 'road.arterial',           elementType: 'geometry.fill',      stylers: [{ color: '#5c513c' }] },
    { featureType: 'road.highway',            elementType: 'geometry.fill',      stylers: [{ color: '#5c513c' }] },
    { featureType: 'road.highway',            elementType: 'geometry.stroke',    stylers: [{ visibility: 'off' }] },
    { featureType: 'road.local',              elementType: 'geometry.fill',      stylers: [{ visibility: 'off' }] },
    { featureType: 'transit',                 elementType: 'geometry',           stylers: [{ color: '#362b16' }] },
    { featureType: 'transit',                 elementType: 'labels.icon',        stylers: [{ visibility: 'off' }] },
    { featureType: 'transit.station',         elementType: 'geometry.stroke',    stylers: [{ color: '#746a57' }] },
    { featureType: 'transit.station.airport', elementType: 'geometry.fill',      stylers: [{ color: '#362b16' }] },
    { featureType: 'transit.station.rail',    elementType: 'geometry.fill',      stylers: [{ color: '#5c513c' }] },
    { featureType: 'water',                   elementType: 'geometry',           stylers: [{ color: '#362b16' }] },
    { featureType: 'water',                   elementType: 'labels.text.fill',   stylers: [{ color: '#9b907b' }] },
  ];
  

  // mark-locator.svg path used as a Google Maps Symbol — avoids data-URI / CSP issues
  var SVG_PATH = 'M13.1851 0C6.2629 0 0 5.30699 0 13.5147C0 18.7557 4.03792 24.9198 12.0973 32.0232C12.7236 32.5671 13.663 32.5671 14.2893 32.0232C22.3322 24.9198 26.3701 18.7557 26.3701 13.5147C26.3701 5.30699 20.1072 0 13.1851 0ZM13.1851 16.4813C11.3721 16.4813 9.88879 14.998 9.88879 13.1851C9.88879 11.3721 11.3721 9.88879 13.1851 9.88879C14.998 9.88879 16.4813 11.3721 16.4813 13.1851C16.4813 14.998 14.998 16.4813 13.1851 16.4813Z';

  function makeIcon(fillColor, strokeColor, strokeWeight) {
    return {
      path: SVG_PATH,
      fillColor: fillColor,
      fillOpacity: 1,
      strokeColor: strokeColor || fillColor,
      strokeWeight: strokeWeight || 0,
      scale: 1,
      anchor: new google.maps.Point(13, 33)
    };
  }

  function initMapSection(config, outlets) {
    var mapEl = document.getElementById('map-' + config.sectionId);
    if (!mapEl || !window.google || !window.google.maps) return;

    var allOutlets = outlets.slice();
    outlets = outlets.filter(function (o) {
      return o.lat !== null && o.lng !== null
        && !isNaN(parseFloat(o.lat)) && !isNaN(parseFloat(o.lng));
    });

    if (allOutlets.length === 0) {
      console.warn('[Points Official] No outlets linked in section settings — open the theme editor and add outlets under "Points de vente officiels".');
    } else if (outlets.length === 0) {
      console.warn(
        '[Points Official] ' + allOutlets.length + ' outlet(s) found but 0 have valid coordinates. '
        + 'Check that the Outlet metaobject has "latitude" and "longitude" fields (handles must be exactly: latitude / longitude) '
        + 'and that each entry has a numeric value set.\nFirst outlet raw data:',
        allOutlets[0]
      );
    }

    var mapOpts = {
      disableDefaultUI: true,
      zoomControl: true,
      gestureHandling: 'cooperative',
      styles: MAP_STYLES,
      zoom: config.defaultZoom || 12
    };
    if (config.centerLat && config.centerLng) {
      mapOpts.center = { lat: parseFloat(config.centerLat), lng: parseFloat(config.centerLng) };
    } else if (outlets.length === 0) {
      mapOpts.center = { lat: 50.85045, lng: 4.34878 }; // Brussels fallback
    }

    var map = new google.maps.Map(mapEl, mapOpts);
    // Using InfoWindow — handles auto-pan and positioning automatically.
    // Default chrome (border, close button) stripped via .points-official-section CSS overrides.
    var infoWin      = new google.maps.InfoWindow({ maxWidth: 260 });
    var activeMarker = null;
    var bounds       = new google.maps.LatLngBounds();

    outlets.forEach(function (outlet) {
      var lat = parseFloat(outlet.lat);
      var lng = parseFloat(outlet.lng);
      var pos = { lat: lat, lng: lng };
      var marker = new google.maps.Marker({
        position: pos,
        map: map,
        icon: makeIcon('#312B23', null),
        title: outlet.name || '',
        optimized: false
      });
      var url = outlet.map_url ? outlet.map_url : 'https://www.google.com/maps/search/?api=1&query='+lat+','+lng;
      bounds.extend(pos);

      marker.addListener('click', function () {
        if (activeMarker && activeMarker !== marker) {
          activeMarker.setIcon(makeIcon('#312B23', null));
        }
        // marker.setIcon(makeIcon('#FFFFFF', '#312B23', 1.5)); //if with border
        marker.setIcon(makeIcon('#FFFFFF', null));
        activeMarker = marker;

        var img = outlet.image
          ? '<img src="' + outlet.image
            + '" alt="' + (outlet.name || '').replace(/"/g, '&quot;')
            + '" class="map-popover__img" />'
          : '';
        var body = '<div class="map-popover__body">'
          + '<p class="map-popover__name">' + (outlet.name || '') + '</p>'
          + (outlet.address ? '<div><a href="'+url+'" target="_blank" class="map-popover__address line-multiline">' + outlet.address + '</a></div>' : '')
          + '</div>';

        infoWin.setContent('<div class="map-popover">' + img + body + '</div>');
        infoWin.open({ anchor: marker, map: map });
      });
    });

    map.addListener('click', function () {
      infoWin.close();
      if (activeMarker) { activeMarker.setIcon(makeIcon('#312B23', null)); activeMarker = null; }
    });
    infoWin.addListener('closeclick', function () {
      if (activeMarker) { activeMarker.setIcon(makeIcon('#312B23', null)); activeMarker = null; }
    });

    if (outlets.length > 0 && !config.centerLat) {
      if (outlets.length === 1) {
        map.setCenter({ lat: parseFloat(outlets[0].lat), lng: parseFloat(outlets[0].lng) });
        map.setZoom(config.defaultZoom || 12);
      } else {
        map.fitBounds(bounds);
      }
    }
  }

  function initAllMaps() {
    document.querySelectorAll('script[id^="map-config-"]').forEach(function (configEl) {
      var config, outlets;
      try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
      var outletEl = document.getElementById('outlets-data-' + config.sectionId);
      try { outlets = outletEl ? JSON.parse(outletEl.textContent) : []; } catch (e) { outlets = []; }
      console.log({ outlets })
      initMapSection(config, outlets);
    });
  }

  // Named global callback for the Maps API async loader
  window.initMapsPoints = initAllMaps;

  // Lazy-init each map section via IntersectionObserver
  document.querySelectorAll('div.points-official__map[id^="map-"]').forEach(function (mapEl) {
    var sectionId = mapEl.id.replace(/^map-/, '');
    var configEl  = document.getElementById('map-config-' + sectionId);
    if (!configEl) return;
    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
    if (!config.apiKey) return;

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      if (window.google && window.google.maps) { initAllMaps(); return; }
      if (document.querySelector('script[data-maps-section="' + sectionId + '"]')) return;
      var s = document.createElement('script');
      // Dynamically injected — RemoteAsset check does not apply to runtime-created tags.
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + config.apiKey + '&loading=async&callback=initMapsPoints';
      s.async = true;
      s.defer = true;
      s.setAttribute('data-maps-section', sectionId);
      document.head.appendChild(s);
    }, { rootMargin: '200px' });
    observer.observe(mapEl);
  });

  // Re-init in the theme editor when the section reloads or is selected
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAllMaps);
    document.addEventListener('shopify:section:select', function () {
      if (window.google && window.google.maps) initAllMaps();
    });
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-points-official"] && !Shopify.designMode) return;
  try {
    
(function () {
  async function setupMap(cfg) {
    var sectionId = cfg.sectionId;
    var hasCenter = cfg.hasCenter;

    var mapEl = document.getElementById('map-' + sectionId);
    var popup = document.getElementById('popup-' + sectionId);
    if (!mapEl || !popup) return;

    var activeMarker = null;

    await mapEl.ready;

    var skeletonEl = document.getElementById('map-skeleton-' + sectionId);
    if (skeletonEl) {
      skeletonEl.classList.add('is-hidden');
      setTimeout(function () { if (skeletonEl.parentNode) skeletonEl.parentNode.removeChild(skeletonEl); }, 400);
    }

    var map = mapEl.innerMap;
    map.setOptions({ clickableIcons: false });
    var markers = Array.from(mapEl.querySelectorAll('gmp-advanced-marker'));

    function positionPopup() {
      if (!activeMarker || popup.hidden) return;
      var mRect = activeMarker.getBoundingClientRect();
      var cRect = mapEl.getBoundingClientRect();
      popup.style.left = (mRect.left - cRect.left + mRect.width / 2) + 'px';
      popup.style.top  = (mRect.bottom - cRect.top) + 'px';
    }

    function closePopup() {
      popup.hidden = true;
      if (activeMarker) {
        activeMarker.querySelector('.points-official__pin-wrapper').classList.remove('is-selected');
        activeMarker = null;
      }
    }

    map.addListener('click', closePopup);
    map.addListener('center_changed', positionPopup);
    map.addListener('zoom_changed', positionPopup);

    var bounds   = new google.maps.LatLngBounds();
    var pinCount = 0;

    markers.forEach(function (marker) {
      var posAttr = marker.getAttribute('position');
      if (!posAttr) return;
      var parts = posAttr.split(',');
      var lat = parseFloat(parts[0]);
      var lng = parseFloat(parts[1]);
      if (isNaN(lat) || isNaN(lng)) return;

      // Declarative attribute is not auto-parsed by gmp-advanced-marker;
      // set the JS property so the marker actually lands at the right LatLng.
      marker.position = { lat: lat, lng: lng };

      bounds.extend({ lat: lat, lng: lng });
      pinCount++;

      marker.addEventListener('gmp-click', function () {
        if (activeMarker && activeMarker !== marker) {
          activeMarker.querySelector('.points-official__pin-wrapper').classList.remove('is-selected');
        }

        marker.querySelector('.points-official__pin-wrapper').classList.add('is-selected');
        activeMarker = marker;

        var name    = marker.dataset.name    || '';
        var address = marker.dataset.address || '';
        var image   = marker.dataset.image   || '';

        popup.querySelector('.points-official__popup-name').textContent    = name;
        popup.querySelector('.points-official__popup-address').textContent = address;

        var thumbEl = popup.querySelector('.points-official__popup-thumb');
        thumbEl.src     = image;
        thumbEl.alt     = name;
        thumbEl.hidden  = !image;

        popup.hidden = false;
        positionPopup();
      });
    });

    if (!hasCenter) {
      if (pinCount > 1)        { map.fitBounds(bounds); }
      else if (pinCount === 1) { map.setCenter(bounds.getCenter()); }
    }
  }

  function initAllMaps() {
    document.querySelectorAll('[data-map-config]').forEach(function (el) {
      try { setupMap(JSON.parse(el.textContent)); } catch (e) {}
    });
  }

  window.initMapsPoints = initAllMaps;

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAllMaps);
    document.addEventListener('shopify:section:select', function () {
      if (window.google && window.google.maps) initAllMaps();
    });
  }

  if (window.google && window.google.maps) initAllMaps();
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    url.hash = '';
    history.replaceState(history.state, '', url.toString());
  }

  } catch(e) { console.error(e); }
})();
})();
